import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faShop } from "@fortawesome/free-solid-svg-icons";
import StoreBlock from "../../Components/Stores";
import Utils from "../../configs/Utils";
import { Button, Tab, Tabs } from "react-bootstrap";
import PopupModal from "../../Components/Common/Popup";
import { useAuth } from "../../contexts/AuthContext";
import CopyButton from "../../Components/Common/CopyButton";
import WoocommerceStoreForm from "../../Components/Stores/Woocommerce/wooStoreForm";
import PageHeader from "../../Components/Common/PageHeader";

const StoresPage = () => {
  const [popupShow, setPopupShow] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    Utils.setPageTitle("Stores page");
  }, []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader 
          title="Store List" 
          description="Woocommerce, Tiktok shop, Shopify" 
          icon={faShop} 
        >
          <Button
            variant="dark"
            size="sm"
            onClick={() => setPopupShow(true)}
          >
            <FontAwesomeIcon className="me-2" icon={faPlus} />
            Add New Store
          </Button>
        </PageHeader>

        <StoreBlock />
        <PopupModal
          title="Add store"
          popupShow={popupShow}
          setPopupShow={setPopupShow}
        >
          <Tabs
            defaultActiveKey="tiktok-shop"
            className="mb-3"
            id="add-new-store-tabs"
          >
            <Tab eventKey="tiktok-shop" title="Tiktok shop">
              <h5>Copy authorization link</h5>
              <CopyButton
                textToCopy={`https://services.tiktokshops.us/open/authorize?service_id=7445647539631753003&state=${currentUser?._id}`}
              />
            </Tab>
            <Tab eventKey="woocommerce" title="Woocommerce">
              <WoocommerceStoreForm />
            </Tab>
          </Tabs>
        </PopupModal>
      </div>
    </main>
  );
};

export default StoresPage;
